import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div<{ $isShow: boolean }>`
	width: 40vw;
	max-width: 500px;
	display: ${(props) => (props.$isShow ? 'flex' : 'none')};
	flex-direction: column;
	gap: 1.5rem;
	height: 100%;
	overflow: auto;

	@media (max-width: 1000px) {
		width: 50vw;
		max-width: 50vw;
	}
`;

export const twoInputs = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 1.5rem;
	box-sizing: border-box;

	@media (max-width: 1000px) {
		grid-template-columns: 1fr;
	}
`;

export const qtdProdutos = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	> p {
		font-size: 1.2rem;
		color: ${color.interface.lightGray};
	}
`;
